import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faChartNetwork, faClock, faCloudUpload, faCreditCard, faGift, faIdCard, faMessageSmile, faNetworkWired, faPlus, faRetweetAlt, faScrewdriverWrench, faShieldAlt, faTag, faUsersCog, faUserTie } from '@fortawesome/pro-regular-svg-icons';
import { UserRoles } from 'src/common/enums';
import type { AdminLinkWithId } from '../header.types';
const networksLink = {
  icon: faNetworkWired,
  title: 'Networks',
  href: '/admin/networks',
  visible: true,
  id: 1
};
const userFeedbackLink = {
  icon: faMessageSmile,
  title: 'Feedback',
  href: '/admin/user-feedback',
  visible: true,
  id: 2
};
const occupationDetailsLink = {
  icon: faIdCard,
  title: 'Occupation Details',
  href: '/admin/user-occupation-details',
  visible: true,
  id: 3
};
const manageUsersLink = {
  icon: faUsersCog,
  title: 'Manage Users',
  href: '/admin/manage-users',
  visible: true,
  id: 4
};
const corporateLink = {
  icon: faUserTie,
  title: 'Corporate',
  href: '/admin/corp',
  visible: true,
  id: 5
};
const cloudTrainingLink = {
  icon: faCloudUpload,
  title: 'Cloud Training',
  href: '/admin/cloud',
  visible: true,
  id: 6
};
const submissionsLink = {
  icon: faRetweetAlt,
  title: 'Submissions',
  href: '/admin/submissions',
  visible: true,
  id: 7
};
const taggingLink = {
  icon: faTag,
  title: 'Tagging',
  href: '/admin/tagging',
  visible: true,
  id: 8
};
const categorizaionDashboardLink = {
  icon: faChartNetwork,
  title: 'Categorization Dashboard',
  href: '/admin/categorization-dashboard',
  visible: true,
  id: 9
};
const cronLink = {
  icon: faClock,
  title: 'Cron Jobs',
  href: '/admin/cron-jobs',
  visible: true,
  id: 10
};
const cddAccessLink = {
  icon: faShieldAlt,
  title: 'CDD Access',
  href: '/admin/cdd-access',
  visible: true,
  id: 11
};
const subscriptionsLink = {
  icon: faCreditCard,
  title: 'Subscriptions',
  href: '/admin/subscriptions',
  visible: true,
  id: 12
};
const createModuleLink = {
  icon: faPlus,
  title: 'Create Module',
  href: '/admin/create-module',
  visible: true,
  id: 13
};
const influencerCampaignsLink = {
  icon: faYoutube,
  title: 'Campaigns',
  href: '/admin/campaigns',
  visible: true,
  id: 14
};
const ticketingEventManagementLink = {
  icon: faGift,
  title: 'Ticketing Event Management',
  href: '/admin/ticketing-event-management',
  visible: true,
  id: 15
};
const ttxManagementLink = {
  icon: faScrewdriverWrench,
  title: 'TTX Admin',
  href: '/tabletop-exercises/manage',
  visible: true,
  id: 16
};
export const adminLinks = [networksLink, userFeedbackLink, occupationDetailsLink, manageUsersLink, corporateLink, cloudTrainingLink, submissionsLink, taggingLink, categorizaionDashboardLink, cronLink, cddAccessLink, subscriptionsLink, createModuleLink, influencerCampaignsLink, ticketingEventManagementLink, ttxManagementLink];
export const linksByRole: { [key in UserRoles]?: AdminLinkWithId[] } = {
  [UserRoles.ANALYST]: [userFeedbackLink],
  [UserRoles.SDR]: [userFeedbackLink, occupationDetailsLink],
  [UserRoles.BDM]: [userFeedbackLink, occupationDetailsLink, corporateLink, cloudTrainingLink],
  [UserRoles.MOD]: [manageUsersLink, cddAccessLink, influencerCampaignsLink, ticketingEventManagementLink],
  [UserRoles.TESTER]: [submissionsLink],
  [UserRoles.BETA_TESTER]: [submissionsLink],
  [UserRoles.TAG_ADMIN]: [taggingLink],
  [UserRoles.CONTENT_DEV_INTERNAL]: [cloudTrainingLink],
  [UserRoles.AZURE_ADMIN]: [cloudTrainingLink],
  [UserRoles.CATEGORIZATION_RULE_DEV]: [categorizaionDashboardLink],
  [UserRoles.EDITOR]: [createModuleLink],
  [UserRoles.TTX_ADMIN]: [ttxManagementLink]
};